import { read, utils } from 'xlsx';
/**
 * @param binary
 */
export function parseHidenXLSX(binary) {
    const workbook = read(binary, { type: 'array' });
    const scanSetup = parseScanSetup(utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
        header: 1,
    }));
    const data = parseData(utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]], {
        header: 1,
    }));
    return { scanSetup, data };
}
function parseScanSetup(matrix) {
    const headers = matrix[0];
    const data = matrix.slice(1);
    const array = [];
    for (let row of data) {
        const data = {};
        for (let i = 0; i < headers.length; i++) {
            data[headers[i]] = row[i];
        }
        array.push(data);
    }
    const result = {};
    array.forEach((item) => (result[item['Gas Name']] = item));
    return result;
}
function parseData(matrix) {
    // The first defines the categories
    const categoriesLabel = matrix[0];
    const categories = {};
    // The second row contains the headers
    const headers = matrix[1];
    let from = 0;
    let currentCategory = categoriesLabel[0];
    for (let i = 0; i < headers.length; i++) {
        if (headers[i] === undefined || i === headers.length - 1) {
            categories[currentCategory] = getVariables(matrix, from, i - 1);
            from = i + 1;
            currentCategory = categoriesLabel[i + 1];
        }
    }
    return categories;
}
function getVariables(matrix, from, to) {
    const headers = matrix[1].slice(from, to + 1);
    matrix = matrix.slice(2);
    const submatrix = matrix.map((row) => row.slice(from, to + 1));
    const variables = headers.map((label) => {
        return { label, data: [] };
    });
    for (let row of submatrix) {
        for (let i = 0; i < variables.length; i++) {
            if (!row[i])
                continue;
            variables[i].data.push(row[i]);
        }
    }
    const result = {};
    variables.forEach((variable) => (result[variable.label] = variable));
    return result;
}
//# sourceMappingURL=parseHidenXLSX.js.map